import styled from 'styled-components'
import { colors, breakpoints, fontWeights } from '@/styles'
import { ParagraphMedium } from '@/components/text'
import FormPanel from '@/components/panel'

export const DashboardPanel = styled(FormPanel).attrs({ hSpace: 0, vSpace: 0 })`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const DashboardContent = styled.div<{ bottom?: string }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;

  @media screen and (max-width: ${breakpoints.phoneMax}) {
    width: 100%;
    margin-bottom: ${props => props.bottom ?? 24}px;
    text-align: center;
  }
`

export const DashboardRow = styled.div<{ top?: string; bottom?: string }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 32px;
  ${props => props.top && `padding-top: ${props.top};`}
  ${props => props.bottom && `padding-bottom: ${props.bottom};`}

  @media screen and (max-width: ${breakpoints.phoneMax}) {
    flex-direction: column;

    > button,
    a {
      width: 100%;
    }
  }
`

export const DashboardTitle = styled.p`
  width: 200px;
  color: ${colors.grey16};
  font-size: 16px;
  line-height: 20px;
  font-weight: 700;
  margin: 0 0 8px;
  width: 100%;
  display: flex;
  align-items: center;

  @media screen and (max-width: ${breakpoints.phoneMax}) {
    justify-content: center;
  }
`

export const DashboardDescription = styled(ParagraphMedium)`
  flex: 1;
  color: ${colors.grey56};
  margin-right: 64px;
  font-weight: ${fontWeights.regular};
  line-height: 20px;

  @media screen and (max-width: ${breakpoints.phoneMax}) {
    margin: 0;
    width: 100%;
  }
`
